import React from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";

// Popper em vez de Menu/Popover: com disableScrollLock o Popover fica parado no viewport quando a pagina rola
export const PainelAncorado = ({
  ancora,
  aoFechar,
  children,
}: {
  ancora: HTMLElement | null;
  aoFechar: () => void;
  children: React.ReactNode;
}) => (
  <Popper open={Boolean(ancora)} anchorEl={ancora} placement="bottom-start" style={{ zIndex: 1300 }}>
    <ClickAwayListener
      onClickAway={(evento) => {
        if (!ancora || !ancora.contains(evento.target as Node)) aoFechar();
      }}
    >
      <Paper
        elevation={8}
        style={{ marginTop: 4 }}
        onKeyDown={(evento) => {
          if (evento.key === "Escape") aoFechar();
        }}
      >
        {children}
      </Paper>
    </ClickAwayListener>
  </Popper>
);
